//colors
import {
  red,
  orange,
  deepOrange,
  green,
  cyan,
  indigo,
  purple,
  pink,
  blueGrey,
  amber,
  blue,
} from "@mui/material/colors";

export const TAG_COLORS = [
    red["100"],
    deepOrange["100"],
    orange["100"],
    amber["100"],
    green["100"],
    cyan["100"],
    blue["100"],
    indigo["100"],
    purple["100"],
    pink["100"],
    blueGrey["100"],
];

const TAG_COLORS_DARK_MAP: Record<string, string> = {
  [red["100"]]: red["900"],
  [deepOrange["100"]]: deepOrange["900"],
  [orange["100"]]: orange["900"],
  [amber["100"]]: amber["900"],
  [green["100"]]: green["900"],
  [cyan["100"]]: cyan["900"],
  [blue["100"]]: blue["900"],
  [indigo["100"]]: indigo["900"],
  [purple["100"]]: purple["900"],
  [pink["100"]]: pink["900"],
  [blueGrey["100"]]: blueGrey["900"],
};

export const getNextTagColor = (existingTags: { color?: string }[]): string => {
  const tagsWithColors = existingTags.filter((tag) => !!tag.color);
  const nextIndex = tagsWithColors.length % TAG_COLORS.length;
  return TAG_COLORS[nextIndex];
};

export const getTagDisplayColor = (color: string | undefined, isDark: boolean): string | undefined => {
  if (!color) return undefined;
  if (!isDark) return color;
  return TAG_COLORS_DARK_MAP[color] || color;
};
